// src/modules/operaciones/inventarios/utils/exportarCsvPrecios.js
//
// Exporta la lista de alertas de precios a un archivo CSV.

/* ---------- Exportar CSV (Blob + object URL, sin dependencias) ---------- */
// Escapa una celda de texto: antepone `'` si empieza con =, +, -, @, tab o retorno (evita inyección de fórmulas
// en Excel) y envuelve el valor entre comillas duplicando las comillas internas
const celdaTexto = (v) => {
  let s = String(v ?? '');
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
};

// Genera y descarga un CSV con las filas recibidas (la lista ya filtrada y ordenada)
export function exportarCsv(filas) {
  const encabezado = ['Código', 'Nombre', 'Tipo', 'Existencia total', 'Precio actual', 'Costo promedio', 'Estado artículo', 'Bodegas con existencia'];
  const lineas = [encabezado.map(celdaTexto).join(',')]; // Primera línea: encabezados
  for (const a of filas) {
    lineas.push([
      celdaTexto(a.CODIGO),
      celdaTexto(a.NOMBRE),
      celdaTexto(a.TIPO_ALERTA === 'NEGATIVO' ? 'Negativo' : 'Costo 0'),
      Number(a.EXISTENCIA_TOTAL ?? 0),
      Number(a.PRECIO_ACTUAL ?? 0),
      Number(a.COSTO_PROMEDIO ?? 0),
      celdaTexto(a.ESTADO_ARTICULO),
      Number(a.BODEGAS_CON_EXISTENCIA ?? 0),
    ].join(','));
  }
  const blob = new Blob(['\ufeff' + lineas.join('\r\n')], { type: 'text/csv;charset=utf-8;' }); // El BOM (\ufeff) hace que Excel lea bien los acentos
  const url = URL.createObjectURL(blob); // URL temporal del archivo en memoria
  const enlace = document.createElement('a'); // Enlace invisible que dispara la descarga
  enlace.href = url;
  enlace.download = `ajustar-precios-${new Date().toISOString().slice(0, 10)}.csv`; // Nombre: ajustar-precios-YYYY-MM-DD.csv
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000); // Libera la URL temporal tras iniciar la descarga
}